export enum ContactGroups {
    'Pre-MBA' = 'Pre-MBA',
    'Post' = 'Post',
    'PortOps' = 'PortOps',
    'Real Estate' = 'Real Estate',
}
